import {useProductsContext} from "../../../context/products/products-context";
import {NoProducts} from "../no-products";
import {ProductListTable} from "./product-list-table";

export function ProductListPage() {
  const {state} = useProductsContext();
  if (!state.products) {
    return <div></div>;
  }

  const hasProduct = state.products.length > 0;
  return <div>{hasProduct ? <ProductListTable /> : <NoProducts />}</div>;
}
